export const numbersOnly = /^[0-9]*$/;
export const positiveNumbersOnly = /^[1-9]+[0-9]*$/;
export const email =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PIN = /^[0-9]{4}$/;
export const TID = /^[12700000-12709999]$/;
export const OIB = /^[0-9]{11}$/;
export const lettersAndNumbers = /^[A-Ža-ž0-9 _]*[A-Ža-ž0-9][A-Ža-ž0-9 _]*$/;
export const lettersOnly = /^[a-žA-Ž\s]*$/;
export const phoneNumber = /^[- +()]*[0-9][- +()0-9]*$/;
export const iban = /^HR\d{19}$/;
export const ibanNum = /^\d{19}$/;
export const storeTag = /^[a-zA-Z0-9]{1,20}$/;
export const posTag = /^[0-9]{1,5}$/;
export const identificationNumber = /^[0-9]{7,13}$/;
export const numbersAndDot = /[0-9]*\.?[0-9]*/;
export const passwordPattern =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@.$%^&*-]).{8,}$/;
export const ictNumber = /([A-Za-z0-9\-_]+)/;
export const address = /^[A-Ža-ž0-9 _]*[A-Ža-ž0-9\.][A-Ža-ž0-9\. _]*$/;
